const DEFAULT_API_BASE_URL = "http://127.0.0.1:3500";

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, "");
const trimLeadingSlashes = (value: string) => value.replace(/^\/+/, "");

const getInitialBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL?.trim()) {
    return process.env.REACT_APP_API_BASE_URL.trim();
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return DEFAULT_API_BASE_URL;
};

export const API_BASE_URL = trimTrailingSlashes(getInitialBaseUrl());


export const joinBaseUrl = (baseUrl: string, path: string) =>
  `${trimTrailingSlashes(baseUrl)}/${trimLeadingSlashes(path)}`;

export const apiUrl = (path: string) => joinBaseUrl(API_BASE_URL, path);

export const toWebSocketBaseUrl = (httpBaseUrl: string) => {
  const url = new URL(httpBaseUrl);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return trimTrailingSlashes(url.toString());
};

export const wsUrl = (path: string) =>
  joinBaseUrl(toWebSocketBaseUrl(API_BASE_URL), path);

const activeSessionToken = () => {
  if (typeof window === "undefined") return "";
  const match = window.location.pathname.match(/\/chat\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : "";
};

const addSessionToken = (value: string, token?: string) => {
  const sessionToken = token || activeSessionToken();
  if (!sessionToken) return value;

  const url = new URL(value, API_BASE_URL);
  if (!url.searchParams.has("token")) {
    url.searchParams.set("token", sessionToken);
  }
  return url.toString();
};

export const assetUrl = (value: string, token?: string) => {
  if (value.startsWith("local://")) {
    return addSessionToken(
      apiUrl(`/uploads/${trimLeadingSlashes(value.slice("local://".length))}`),
      token
    );
  }
  if (value.startsWith("/uploads/") || value.startsWith("uploads/")) {
    return addSessionToken(apiUrl(value), token);
  }
  return value;
};

const decodeUrlComponent = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const fileNameFromUrl = (value: string) => {
  try {
    const url = new URL(value, API_BASE_URL);
    const encodedName = url.pathname.split("/").filter(Boolean).pop() || "";
    return decodeUrlComponent(encodedName);
  } catch {
    const path = value.split(/[?#]/, 1)[0].replace(/\\/g, "/");
    return decodeUrlComponent(path.split("/").filter(Boolean).pop() || "");
  }
};

export const cleanArtifactFileName = (fileName: string, fileUrl = "") => {
  const name = fileNameFromUrl(fileName.trim()) || fileNameFromUrl(fileUrl);
  return name.replace(/^gen_[0-9a-f]{6}_/i, "") || "downloaded_file";
};
